import { roundOff } from '../../../../lib/utils';

export default function PriceCalculator({
  lodgings,
  flights,
  noOfPeople: pax,
  porters,
  guides,
  selectedGuideType,
  noOfPorter,
  numberOfDays,
  inbound,
  outbound,
  isFlightsAvailable,
  userIsPickingDatesOrPax,
}) {
  const isOneWayFlight = flights.length === 1;

  // ----------------------------------------
  // FLIGHT PRICE
  // ----------------------------------------

  const getTotalFlightPrice = () => {
    // when the user searches for the flight on review page
    // and the search query is processed with valid response
    // take the total amount from the search query.
    if (!userIsPickingDatesOrPax && isFlightsAvailable)
      return (
        Number(outbound.total_amount) + (isOneWayFlight ? 0 : Number(inbound.total_amount))
      );

    // this happens on the initial loading of the page
    // and when the user is in the state of picking dates or pax
    return getFlightPriceFromReview(flights) * pax;
  };

  // ----------------------------------------
  // GUIDE/LEADER PRICE WITH FLIGHTS
  // ----------------------------------------

  const FLIGHT_PRICE = isOneWayFlight ? 80 : 160;
  const guideOrLeaderPriceWithFlights =
    selectedGuideType !== 'none'
      ? Number(guides[selectedGuideType].amount) * Number(numberOfDays) + FLIGHT_PRICE
      : 0;

  // ----------------------------------------
  // PORTER PRICE
  // ----------------------------------------

  const totalPorterPrice =
    noOfPorter > 0
      ? Number(noOfPorter) * Number(porters.amount) * (Number(numberOfDays) - 1)
      : 0;

  // ----------------------------------------
  // TOTAL PRICE
  // ----------------------------------------

  const totalFlightPrice = roundOff2(getTotalFlightPrice());
  const totalLodgePrice = roundOff2(getTotalLodgePrice(lodgings) * pax);
  const totalAdditionalPrice = roundOff2(guideOrLeaderPriceWithFlights + totalPorterPrice);
  const totalPrice = roundOff2(totalLodgePrice + totalAdditionalPrice + totalFlightPrice);

  return Object.freeze({
    totalLodgePrice,
    totalFlightPrice,
    totalPrice,
    totalAdditionalPrice,
  });
}

// ----------------------------------------
// Helpers
// ----------------------------------------

const roundOff2 = price => roundOff(price, 2);

const calculateTotal = (total, price) => total + Number(price);

const getTotalLodgePrice = lodgings =>
  lodgings
    .map(({ mealPlan, roomType }) =>
      roomType && mealPlan[roomType.toLowerCase()]
        ? mealPlan[roomType.toLowerCase()].amount
        : 0
    )
    .reduce(calculateTotal, 0);

const getFlightPriceFromReview = flights =>
  flights.map(({ charge }) => (charge ? charge.amount : 0)).reduce(calculateTotal, 0);



// WEBPACK FOOTER //
// ./src/screens/Trek/Self-Guided/Review/PriceCalculator.js